<template>
    <div>
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form-model layout="inline" :model="queryParam" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="12" :sm="8">
              <a-form-model-item :label="$t('dashboard.analysis.warehouseName')" prop="warehouseName">
                <a-input :placeholder="$t('dashboard.analysis.plWarehouseName')" v-model="queryParam.warehouseName"/>
              </a-form-model-item>
            </a-col>
            <a-col :md="12" :sm="8">
              <a-form-model-item :label="$t('dashboard.analysis.warehouseCode')" prop="warehouseCode">
                <a-input :placeholder="$t('dashboard.analysis.plwarehouseCode')" v-model="queryParam.warehouseCode"/>
              </a-form-model-item>
            </a-col>
            <template v-if="toggleSearchStatus">
            </template>
          </a-row>
        </a-form-model>
      </div>

      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button type="primary" @click="searchQuery" icon="search">{{ $t('antd.table.search') }}</a-button>
        <a-button type="primary" @click="searchReset({
          siteId:queryParam.siteId
        })" icon="reload">{{ $t('antd.table.reset') }}</a-button>
        <a-button @click="handleAdd({
          siteId:queryParam.siteId,
        })" type="primary" icon="plus">{{ $t('antd.table.add') }}</a-button>
        <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel">
              <a-icon type="delete"/>
              {{ $t('antd.table.delect') }}
            </a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> {{ $t('antd.table.batchOperation') }}
            <a-icon type="down"/>
          </a-button>
        </a-dropdown> -->
      </div>

      <!-- table区域-begin -->
      <a-alert type="info" showIcon style="margin-bottom: 16px;">
        <template slot="message">
          <span>{{ $t('antd.table.selected') }}</span>
          <a style="font-weight: 600;padding: 0 4px;">{{ selectedRowKeys.length }}</a>
          <span>{{ $t('antd.table.item') }}</span>
          <template v-if="selectedRowKeys.length>0">
            <a-divider type="vertical"/>
            <a @click="onClearSelected">{{ $t('antd.table.clear') }}</a>
          </template>
        </template>
      </a-alert>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="action" slot-scope="text, record">
          <a @click="handleActic(record)">{{ $t('dashboard.analysis.passage') }}</a>
          <a-divider type="vertical"/>
          <a @click="handleEdit(record)">{{ $t('antd.table.edit') }}</a>
          <a-divider type="vertical"/>
          <a @click="handleDelete(record.id)">{{ $t('antd.table.delect') }}</a>
        </template>

      </a-table>

      <!-- 表单区域 -->
      <AisleCopyCreate ref="modalForm" @ok="modalFormOk"/>
    </div>
      <!-- table区域-end -->

      <!-- <sys-check-rule-test-modal ref="testModal"/> -->
  </template>

  <script>
   import AisleCopyCreate from './modules/AisleCopyCreate.vue'
   // import SysCheckRuleTestModal from './modules/SysCheckRuleTestModal'
   import { TableListMixin } from '@/situation/mixins/tableListMixin'
    export default {
      name: 'SysCheckRuleList',
      mixins: [TableListMixin],
      components: {
        AisleCopyCreate
      },
      data() {
        return {
          queryParam:{

          },
          toggleSearchStatus:true,
          selectedRowKeys:[],
          description: '编码校验规则管理页面',
          // 表头
          columns: [
            {
              title: this.$t("dashboard.analysis.warehouseName"),
              align: 'center',
              dataIndex: 'warehouseName'
            },
            {
              title: this.$t("dashboard.analysis.warehouseCode"),
              align: 'center',
              dataIndex: 'warehouseCode'
            },
            {
              title: this.$t("antd.table.createTime"),
              align: 'center',
              dataIndex: 'createTime'
            },
            {
              title: this.$t("antd.table.batch"),
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            }
          ],
          url: {
            selectData: '/ndt/warehouse/page',
            deleteData:'/ndt/warehouse/delete'
          },
        }
      },
      props:{
        acticeData:{
          type: Object,
          required: false,
          default:()=>{
            return {}
          }
        }
      },
      computed: {
        importExcelUrl: function () {
          return ""
        }
      },
      created() {
        this.queryParam.siteId = this.acticeData.id
      },
      methods: {
        handleActic(event){
          this.$emit("onActicWarehouse", event)
        },
        handleTest(record) {
          this.$refs.testModal.open(record.ruleCode)
        }
      }
    }
  </script>
  <style lang="less" scoped>
    @import '~assets/less/common.less';
  </style>
